import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { MasterlocationRepository }  from "../../repositories";


@Injectable({ providedIn: 'root' })
export class ImportPlanContainerLocationCSVUsecase implements UseCase<FormData,boolean> {

  constructor(private readonly masterLocationRepository: MasterlocationRepository) {
  }

  execute(param: FormData): Observable<boolean> {
    return this.masterLocationRepository.importPlanContainerLocationCSV(param);
  }

}
